module.exports = __webpack_public_path__ + "img/chevron-up.0b38ddc4.svg";